import { PerformanceSDK } from './core/PerformanceSDK';
import { PerformanceSDKOptions, PerformanceMetrics } from './types';

// 导出主要类
export { PerformanceSDK };

// 导出类型定义
export type { PerformanceSDKOptions, PerformanceMetrics };

// 创建全局实例的工厂函数
let globalInstance: PerformanceSDK | null = null;

/**
 * 初始化性能监控SDK
 * @param options 配置选项
 * @returns SDK实例
 */
export function initPerformanceSDK(options: PerformanceSDKOptions = {}): PerformanceSDK {
  if (globalInstance) {
    console.warn('PerformanceSDK already initialized');
    return globalInstance;
  }

  globalInstance = new PerformanceSDK(options);
  return globalInstance;
}

/**
 * 获取全局SDK实例
 * @returns SDK实例或null
 */
export function getPerformanceSDK(): PerformanceSDK | null {
  return globalInstance;
}

/**
 * 销毁全局SDK实例
 */
export function destroyPerformanceSDK(): void {
  if (globalInstance) {
    globalInstance.destroy();
    globalInstance = null;
  }
}

/**
 * 获取当前性能指标
 * @returns 性能指标数据
 */
export function getPerformanceMetrics(): PerformanceMetrics {
  if (globalInstance) {
    return globalInstance.getMetrics();
  }
  return {};
}

/**
 * 手动收集并上报数据
 */
export function collectAndReport(): void {
  if (globalInstance) {
    globalInstance.collectAndReport();
  }
}

// 默认导出
export default PerformanceSDK; 